import { getService } from '@/common/services/ngBridge';
import {
  integratorService,
  slaveShownEventPubSub,
  SLAVE_SHOWN_EVENT_ID,
} from '@/modules/integrator';
import TicketCheckStrategyParams from '../types/TicketCheckStrategyParams';

const emitWebCode = (params: TicketCheckStrategyParams) => {
  integratorService.sendEvent(
    'Ticket.CheckWebCode',
    {
      data: {
        code: params.code,
      },
      context: {
        productId: params.productId,
      },
      config: {
        enforceEvent: true,
      },
    },
  );
};

const checkTicketCode = (params: TicketCheckStrategyParams) => {
  const switchView = getService<{ selectService: Function }>('switchView');
  const GravityGatewayService = getService<{ isFrameLoaded: Function }>('GravityGatewayService');
  const { productId } = params;

  return switchView?.selectService(productId, true, {
    gameId: productId,
    genericId: productId,
  }).then(() => {
    if (GravityGatewayService?.isFrameLoaded(productId)) {
      emitWebCode(params);
    } else {
      const slaveShownSubscription = slaveShownEventPubSub
        .subscribe(SLAVE_SHOWN_EVENT_ID, (e, eventData) => {
          if (eventData?.productId === productId) {
            emitWebCode(params);
            slaveShownEventPubSub.unsubscribe(slaveShownSubscription);
          }
        });
    }

    return Promise.resolve(undefined);
  });
};

export default {
  checkTicketCode,
};
